import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SharedModule} from '../../shared/shared.module';
import {SettingsPage} from './settings';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    SettingsPage,
  ],

  imports: [
    CommonModule,
    SharedModule,
    IonicModule,
    FormsModule
  ],
})
export class SettingsPageModule {
}
